// Stub for aws-amplify — Kinde handles auth, Cognito/Amplify is not used.
var I18n = {
  putVocabulariesForLanguage: function() {},
  setLanguage: function() {},
  get: function(key) { return key; }
}

var Hub = {
  listen: function() { return function() {}; },
  remove: function() {},
  dispatch: function() {}
}

function Logger() {}
Logger.prototype.debug = function() {}
Logger.prototype.info = function() {}
Logger.prototype.warn = function() {}
Logger.prototype.error = function() {}

var Auth = {
  currentAuthenticatedUser: function() { return Promise.reject(new Error('Amplify not configured')); },
  signIn: function() { return Promise.reject(new Error('Amplify not configured')); },
  signOut: function() { return Promise.resolve(); },
  signUp: function() { return Promise.reject(new Error('Amplify not configured')); },
  confirmSignIn: function() { return Promise.reject(new Error('Amplify not configured')); },
  confirmSignUp: function() { return Promise.reject(new Error('Amplify not configured')); },
  forgotPassword: function() { return Promise.reject(new Error('Amplify not configured')); },
  forgotPasswordSubmit: function() { return Promise.reject(new Error('Amplify not configured')); },
  verifyTotpToken: function() { return Promise.reject(new Error('Amplify not configured')); },
  verifiedContact: function() { return Promise.reject(new Error('Amplify not configured')); },
  federatedSignIn: function() { return Promise.reject(new Error('Amplify not configured')); },
  completeNewPassword: function() { return Promise.reject(new Error('Amplify not configured')); }
}

var Amplify = {
  configure: function() {},
  Auth: Auth,
  I18n: I18n,
  Hub: Hub
}

module.exports = Amplify
module.exports.default = Amplify
module.exports.Amplify = Amplify
module.exports.Auth = Auth
module.exports.I18n = I18n
module.exports.Hub = Hub
module.exports.Logger = Logger
